import { withStyles } from '@material-ui/styles';

// ----------------------------------------------------------------------

const GlobalStyles = withStyles((theme) => ({
  '@global': {
    '*': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box'
    },
    html: {
      width: '100%',
      height: '100%',
      '-ms-text-size-adjust': '100%',
      '-webkit-text-size-adjust': '100%',
      '-webkit-overflow-scrolling': 'touch',
      touchAction: 'manipulation'
    },
    body: {
      width: '100%',
      height: '100%',
      overflowX: 'hidden',
      fontFamily: theme.typography.fontFamily,
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale'
    },
    '#root': {
      width: '100%',
      height: '100%',
      overflowX: 'hidden'
    },
    'input, textarea, select': {
      fontSize: '16px !important',
      '&:focus': {
        fontSize: '16px !important'
      }
    },
    input: {
      '&[type=number]': {
        MozAppearance: 'textfield',
        '&::-webkit-outer-spin-button': { margin: 0, WebkitAppearance: 'none' },
        '&::-webkit-inner-spin-button': { margin: 0, WebkitAppearance: 'none' }
      }
    },
    textarea: {
      '&::-webkit-input-placeholder': { color: theme.palette.text.disabled },
      '&::-moz-placeholder': { opacity: 1, color: theme.palette.text.disabled },
      '&:-ms-input-placeholder': { color: theme.palette.text.disabled },
      '&::placeholder': { color: theme.palette.text.disabled }
    },
    a: { color: theme.palette.primary.main },
    img: { 
      display: 'block', 
      maxWidth: '100%',
      height: 'auto'
    },
    '.MuiAppBar-root': {
      userSelect: 'none',
      '-webkit-user-select': 'none',
      '-webkit-touch-callout': 'none'
    },
    '.MuiContainer-root': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      }
    }
  }
}))(() => null);

export default GlobalStyles;
